













































import { Component, Vue } from "vue-property-decorator";

import BreadcrumbList, {
  BreadcrumbData,
} from "@/components/common/breadcrumb/BreadcrumbList.vue";
import GreenUnderlineText from "@/components/common/text/GreenUnderlineText.vue";
import EventArea from "@/components/event/EventArea.vue";
import EventServiceName from "@/components/event/EventServiceName.vue";
import FlexibleContentArea from "@/components/layout/FlexibleContentArea.vue";
import ServiceCategoryTab from "@/components/service/ServiceCategoryTab.vue";
import ServiceMenuStatusIcon from "@/components/service-status/ServiceMenuStatusIcon.vue";
import {
  API_ERROR_MESSAGE,
  SERVICE_MENU_STATUS_NAME,
  ServiceMenuStatus,
  ServiceMenuStatusIconType,
} from "@/consts/const";
import { RouteName } from "@/consts/route";
import { ApiNetworkError } from "@/errors/api/api-network-error";
import { ApiResponseNotFoundError } from "@/errors/api/api-response-not-found-error";
import { ServiceMenuAndOneEventResponseInterface } from "@/interfaces/api/service-menu-and-one-event-response.interface";
import { ServiceInterface } from "@/interfaces/service.interface";
import { ServiceCategoryInterface } from "@/interfaces/service-category.interface";
import { ServiceMenuInterface } from "@/interfaces/service-menu.interface";
import { ServiceMenuEventInterface } from "@/interfaces/service-menu-event.interface";
import { ViewUtil } from "@/utils/view.util";

@Component({
  components: {
    GreenUnderlineText,
    ServiceMenuStatusIcon,
    EventServiceName,
    FlexibleContentArea,
    EventArea,
    ServiceCategoryTab,
    BreadcrumbList,
  },
})
export default class EventDetailPage extends Vue {
  private ServiceMenuStatusIconType = ServiceMenuStatusIconType;
  private categories: ServiceCategoryInterface[] = [];
  private category: ServiceCategoryInterface | null = null;
  private service: ServiceInterface | null = null;
  private serviceMenu: ServiceMenuInterface | null = null;
  private event: ServiceMenuEventInterface | null = null;

  async mounted(): Promise<void> {
    this.showLoading();
    ViewUtil.scrollToTop();

    try {
      if (!(await this.setUpCategory()) || !(await this.setUpServiceMenu())) {
        this.$router.push({ name: RouteName.NotFound });
      }

      if (!this.serviceMenu) {
        // 上記で設定済みであり得ないが、念の為
        this.$router.push({ name: RouteName.NotFound });
      } else if (this.serviceMenu.id !== this.getServiceMenuIdFromRoute()) {
        this.$router.push({ name: RouteName.NotFound });
      }
    } catch (e) {
      if (e instanceof ApiNetworkError) {
        this.errorToast(this.$t(API_ERROR_MESSAGE.FAILED_GENERAL).toString());
      } else if (e instanceof ApiResponseNotFoundError) {
        this.$router.push({ name: RouteName.NotFound });
      } else {
        this.errorToast(this.$t(API_ERROR_MESSAGE.FAILED_TO_GET).toString());
      }
    } finally {
      this.hideLoading();
    }
  }

  private async setUpCategory(): Promise<boolean> {
    const categories = await this.$service.getCategories(this);
    const category = this.$service.getCategoryByRouteKey(
      categories,
      this.$route.params.key
    );

    if (!category) {
      return false;
    }

    this.categories = categories;
    this.category = category;

    return true;
  }

  private getServiceMenuIdFromRoute(): number {
    return Number(this.$route.params.serviceMenuId);
  }

  private async setUpServiceMenu(): Promise<boolean> {
    const eventId = this.$route.params.eventId;

    if (!/^[0-9]{12}$/.test(eventId)) {
      return false;
    }

    const data: ServiceMenuAndOneEventResponseInterface =
      await this.$api.getServiceMenuAndOneEvent(eventId);

    this.service = data.service;
    this.serviceMenu = data.serviceMenu;
    this.event = data.event;

    return true;
  }

  private get breadcrumbs(): BreadcrumbData[] {
    const items: BreadcrumbData[] = [{ name: "Home", route: RouteName.Home }];

    if (!this.category) {
      return items;
    }

    items.push({
      name: this.category.name,
      route: RouteName.Service,
      params: { key: this.category.routeKey },
    });

    if (!this.service || !this.serviceMenu) {
      items.push({
        name: this.$t("message.EventDetailPage.status").toString(),
        route: RouteName.ServiceStatus,
        params: { key: this.category.routeKey },
      });
    } else {
      items.push({
        name: this.$t("message.EventDetailPage.status").toString(),
        route: RouteName.ServiceStatus,
        params: { key: this.category.routeKey },
        hash: `#service-${this.service.id}`,
      });
      items.push({
        name: this.serviceMenu.name,
        route: RouteName.EventList,
        params: {
          key: this.category.routeKey,
          serviceMenuId: `${this.serviceMenu.id}`,
        },
      });
    }

    items.push({
      name: this.$t("message.EventDetailPage.status_details").toString(),
    });

    return items;
  }

  private get categoryId(): number {
    if (!this.category) {
      return 0;
    }

    return this.category.id;
  }

  private get serviceStatusName(): string {
    if (!this.event) {
      return "";
    }

    const text = this.$t(
      SERVICE_MENU_STATUS_NAME[this.event.status]
    ).toString();

    if (!text) {
      return "";
    }

    if (
      [ServiceMenuStatus.Warning, ServiceMenuStatus.Error].includes(
        this.event.status
      )
    ) {
      return this.$t("message.EventDetailPage.information_format", { text: text }).toString();
    }

    return text;
  }

  private onClickTab(category: ServiceCategoryInterface): void {
    this.category = category;
    this.$router.push({
      name: RouteName.Service,
      params: { key: category.routeKey },
    });
  }
}
